module.exports = __webpack_public_path__ + "static/divas0s-e853e665195ca1d74286198b8c2d0f0c.jpg";